import Repository from "./RepositoryFactoryMain";
const ADD_PRODUCT = "add";
const EDIT_PRODUCT = "update";
const DELETE_PRODUCT = "delete";
const GET_PRODUCT = "get";
const GET_ALLPRODUCT = "getAll";
const GET_DETAILED_CATEGORY = "getDetailedCategory";
const PRODUCT_IMAGE = "addProductImage";
const EDIT_PRODUCT_IMAGE = "editProductImage";
const DELETE_PRODUCT_IMAGE = "deleteProductImage";
const INSERT_META = "insertMeta";

export default {
  addProduct(payload) {
    return Repository.post(transformRoute(ADD_PRODUCT), payload);
  },
  editProduct(payload) {
    return Repository.post(transformRoute(EDIT_PRODUCT), payload);
  },
  deleteProduct(payload) {
    return Repository.post(transformRoute(DELETE_PRODUCT), payload);
  },
  getProduct() {
    return Repository.post(transformRoute(GET_PRODUCT));
  },
  getAllProduct(payload) {
    return Repository.post(transformRoute(GET_ALLPRODUCT), payload);
  },
  getDetailedCategory() {
    return Repository.post(transformRoute(GET_DETAILED_CATEGORY));
  },
  productImage(payload) {
    return Repository.post(transformRoute(PRODUCT_IMAGE), payload);
  },
  editProductImage(payload) {
    return Repository.post(transformRoute(EDIT_PRODUCT_IMAGE), payload);
  },
  deleteProductImage(payload) {
    return Repository.post(transformRoute(DELETE_PRODUCT_IMAGE), payload);
  },
  insertMeta(payload) {
    return Repository.post(transformRoute(INSERT_META), payload);
  },
};

const transformRoute = (route) => {
  return `/ecom/product/${route}`;
};
